import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Tooltip,
  Typography,
  Table,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import JsFileDownloader from "js-file-downloader";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import useNotify from "../utils/useNotify";
import { getVendorDocs } from "../services/httpCalls";
import SourceIcon from "@mui/icons-material/Source";
import PreviewDocsDownload from "./PreviewDocsDownload";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
const cols = [
  {
    colName: "File Name",
    colId: "file name",
  },
  {
    colName: "File Type",
    colId: "file type",
  },
  {
    colName: "Preview",
    colId: "preview",
  },
  {
    colName: "Download",
    colId: "download",
  },
];
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: ".5rem",
    fontSize: 14,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: ".5rem",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "700px",
  height: "auto",
  bgcolor: "background.paper",
  borderRadius: "10px",

  boxShadow: 24,
};
function VendorDownloadDocs({ VendorId }) {
  const notify = useNotify();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [docs, setDocs] = useState();
  const fetchtableData = async () => {
    await getVendorDocs(VendorId)
      .then((res) => {
        setDocs(res);
      })
      .catch((err) => {
        console.log(err);
      });
    handleOpen();
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
          }}
        >
          Already Uploaded Files
        </Typography>
        <IconButton onClick={fetchtableData}>
          <SourceIcon
            sx={{
              color: "#2862FF",
              fontSize: "32px",
            }}
          />
        </IconButton>
      </Box>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
              p: 1,
            }}
          >
            <Typography
              sx={{
                marginLeft: "20px",
                fontSize: "20px",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
              component="h2"
            >
              View Files
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              marginBottom: "20px",
              paddingBottom: 2,
            }}
          >
            <Typography
              sx={{
                marginLeft: "20px",
                fontSize: "20px",
                textTransform: "uppercase",
                fontWeight: "bold",
              }}
              component="h2"
            ></Typography>

            <Box p={2}>
              {docs?.length ? (
                <>
                  <TableContainer
                    component={Paper}
                    sx={{
                      maxHeight: "340px",
                    }}
                  >
                    <Table
                      stickyHeader
                      sx={{
                        minWidth: 350,
                        overflowY: "scroll",
                      }}
                    >
                      <TableHead>
                        <TableRow>
                          {cols?.map((cols, i) => {
                            return (
                              <StyledTableCell key={i} align="center">
                                {cols.colName}
                              </StyledTableCell>
                            );
                          })}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {docs?.map((value, i) => {
                          let ext = value.documentName.split(".")[1];
                          let showPreview = ext === "zip" ? false : true;
                          return (
                            <StyledTableRow>
                              <StyledTableCell
                                sx={{
                                  width: "20px",
                                }}
                                align="center"
                              >
                                {value.documentName}
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                {value.documentType}
                              </StyledTableCell>
                              {showPreview ? (
                                <StyledTableCell align="center">
                                  <IconButton>
                                    <PreviewDocsDownload
                                      url={value.presignedUrl}
                                    />
                                  </IconButton>
                                </StyledTableCell>
                              ) : (
                                <StyledTableCell align="center">
                                  No Preview
                                </StyledTableCell>
                              )}
                              <StyledTableCell align="center">
                                <IconButton
                                  onClick={() => {
                                    new JsFileDownloader({
                                      url: value.presignedUrl,
                                    })
                                      .then((res) => {
                                        notify.success("Download Success!");
                                      })
                                      .catch((err) => {
                                        notify.error("Download Failed!");
                                      });
                                  }}
                                >
                                  <DownloadIcon
                                    sx={{
                                      color: "#1876D1",
                                    }}
                                  />
                                </IconButton>
                              </StyledTableCell>
                            </StyledTableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : (
                <Box
                  sx={{
                    padding: "3rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <AutoStoriesIcon
                    sx={{
                      fontSize: "100px",
                      color: "#DDE0E4",
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      fontSize: "20px",
                      color: "#DDE0E4",
                    }}
                  >
                    No Data
                  </Typography>
                </Box>
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 3,
                mr: 3,
              }}
            ></Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default VendorDownloadDocs;
